/**
 * @file コンポーネント：共通フッター ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import {
    fnGetCultureLanguage,
    fnHandleApiErrors,
    fnHandleApiSuccess,
} from "~/src/functions/common";

// コンポーネントを返す
export const Footer = () => {
    /**
     * スポンサーユーザーか否かの情報をセット
     */
    const isSponsorUser = window.dataUser.isSponsorUser;

    // 協賛企業リストを取得
    const [partnerlist, setPartnerlist] = useState([]);
    useEffect(() => {
        const api = "/api/parters";
        fetch(api)
            .then(fnHandleApiErrors)
            .then(fnHandleApiSuccess)
            .then((result) => {
                if (result !== null) {
                    const partners = [];
                    result.parterList.forEach((item) => {
                        const partner = {
                            imgSrc: item.logoImageFilePath,
                            name: item.name,
                            url: item.link,
                        };
                        partners.push(partner);
                    });
                    setPartnerlist(partners);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    // Presenterに渡す
    return (
        <Presenter
            isSponsorUser={isSponsorUser}
            partnerlist={partnerlist}
        />
    );
};
